import request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 提交工作室信息
   */
  static getCardTypeGoods(params) {
    return request({
      url: 'user/register/queryCardType',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params,
      ignoreErr: true
    });
  }

  /**
   * 根据卡类型id,类目id,关键词(商品名称，商品编号)查询礼包列表
   */
  static getProductList(params) {
    return request({
      url: 'user/register/listCatalogAndItemList',
      host: config.HOST_MALL,
      params,
      ignoreErr: true
    });
  }

  /**
   * 根据卡类型id,类目id,关键词(商品名称，商品编号)查询礼包列表
   */
  static getShopProductList(params) {
    return request({
      url: 'valetOpenCard/listCatalogAndItemList',
      host: config.HOST_STORE,
      params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Register/ViewPackage/ViewPackageServ.js